//@flow
import * as Immutable from 'immutable';

import {
    LatLngFeedback,
    Reason,
    ZoneFeedback,
    IntelliSortFeedback
} from 'common/models/flow/IntelliSortFeedback';
import type {
    LatLngFeedbackModelType,
    ReasonModelType,
    ZoneFeedbackModelType,
    IntelliSortFeedbackModelType
} from 'common/models/flow/IntelliSortFeedback';

import { LatLng } from './LatLng';
import { AuditMetadata } from './AuditMetadata';

class InternalLatLngFeedback extends LatLngFeedback {
    static fromJS(json: LatLngFeedbackModelType): InternalLatLngFeedback {
        const state: Object = Object.assign({}, json);
        state.latLng = LatLng.fromJS(state.latLng);
        return new this(Immutable.Map(state));
    }

    get latLng(): LatLng {
        return this._state.get('latLng');
    }
}

class InternalReason extends Reason {
    static fromJS(json: ReasonModelType): InternalReason {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }
}

class InternalZoneFeedback extends ZoneFeedback {
    static fromJS(json: ZoneFeedbackModelType): InternalZoneFeedback {
        const state: Object = Object.assign({}, json);
        state.reasons = Immutable.List(state.reasons).map(item =>
            InternalReason.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    get reasons(): Immutable.List<Reason> {
        return this._state.get('reasons');
    }
}

class InternalIntelliSortFeedback extends IntelliSortFeedback {
    static fromJS(
        json: IntelliSortFeedbackModelType
    ): InternalIntelliSortFeedback {
        const state: Object = Object.assign({}, json);
        state.auditMetadata = state.auditMetadata
            ? AuditMetadata.fromJS(state.auditMetadata)
            : state.auditMetadata;
        state.latLngFeedback = InternalLatLngFeedback.fromJS(
            state.latLngFeedback
        );
        state.zoneFeedback = InternalZoneFeedback.fromJS(state.zoneFeedback);
        return new this(Immutable.Map(state));
    }

    get latLngFeedback(): InternalLatLngFeedback {
        return this._state.get('latLngFeedback');
    }

    get zoneFeedback(): InternalZoneFeedback {
        return this._state.get('zoneFeedback');
    }

    get auditMetadata(): ?AuditMetadata {
        return this._state.get('auditMetadata');
    }
}

export {
    InternalLatLngFeedback as LatLngFeedback,
    InternalReason as Reason,
    InternalZoneFeedback as ZoneFeedback,
    InternalIntelliSortFeedback as IntelliSortFeedback
};
